import {QRCodeSVG} from "qrcode.react";
import SpinnerButton from "../../components/common/SpinnerButton";
import React from "react";
import {SetupMfaDiv} from "../../style/StyledElement";

export const SetupMfa = ({mfa, handleClick, title}) => {
    return (
        <SetupMfaDiv>
            <div>
                <h2 className="title">{title}</h2>
            </div>

            <div>
                <QRCodeSVG
                    value={mfa.qrCodeUrl}
                    size={200}
                    level="H"
                    includeMargin={true}
                    aria-label="QR code for registering in Google Authenticator"
                />
            </div>
            <p>
                Scan the QR code with Google Authenticator app on your device.
            </p>
            <SpinnerButton
                label="Verify Device OTP"
                className="btn-block"
                onClick={handleClick}
                buttonColor={"#001645"}
            />
        </SetupMfaDiv>
    );
}